module.exports = new __parcel__URL__("blank-dark.eac9084a.png").toString();